import React, { type PropsWithChildren } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type ProfileCardClient from '@atlaskit/profilecard/client';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useOrgId } from '@atlassian/jira-tenant-context-controller/src/components/org-id/index.tsx';
import { useFabricProfileDirectoryUrl } from '@atlassian/jira-tenant-context-controller/src/components/fabric-profile-directory-url/index.tsx';
import { ProfileClientContainer } from '../../../controllers/profileclient/index.tsx';

export type ProfileCardWrapperProps = {
	externalProfileClient?: ProfileCardClient;
	onLoadError?: (error: Error, analyticsEvent?: UIAnalyticsEvent) => void;
};

export const ProfileCardWrapper = ({
	externalProfileClient,
	children,
	onLoadError,
}: PropsWithChildren<ProfileCardWrapperProps>) => {
	const cloudId = useCloudId();
	const accountId = useAccountId();
	const fabricPfDirUrl = useFabricProfileDirectoryUrl();
	const orgId = useOrgId();

	if (accountId) {
		return (
			<ProfileClientContainer
				fabricPfDirUrl={fabricPfDirUrl}
				profileClient={externalProfileClient || null}
				onLoadError={onLoadError}
				cloudId={cloudId}
				// Only use the global store when no external client is provided
				isGlobal={!externalProfileClient}
				orgId={orgId}
			>
				{children}
			</ProfileClientContainer>
		);
	}

	// When there is no tenantContext, this will cause the child
	// component of <ProfileCard> to render without being wrapped by
	// a profile card and it will do nothing on hover
	return children;
};
